module.exports = __webpack_public_path__ + "static/media/user.59832a3a.svg";